module.exports = __webpack_public_path__ + "static/media/cases_3d_06d.16d71fb9.jpg";